export const LAST_SHOW_ATTENTION_TIME = 'lastShowAttentionTime';

export const LAST_SHOW_QUESTIONNAIRE_TIME = 'lastShowQuestionnaireTime';
